<script lang="ts">
    interface Props {
        dealHighlight?: string;
    }

    let { dealHighlight }: Props = $props();
</script>

{#if dealHighlight}
    <span class="reptile-price__priceHighlightText oc-headline-50">{dealHighlight}</span>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-price {
        &__priceHighlightText {
            white-space: nowrap;
            color: tokens.$oc-base-color-otto-red-100;
        }
    }
</style>
